export default __webpack_public_path__ + "static/media/edit-icon.5bbbe94f.svg";